import {React} from 'react';
import { useNavigate} from 'react-router';
import { resetUserSession } from './AuthService';
import {severProperties} from './utility/Constants';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTableCellsLarge,faFolder,faCircleInfo,faComments } from "@fortawesome/free-solid-svg-icons";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import './css/style.css';
function HeaderMenu(Props) {

  const navigate = useNavigate();

  const doUserLogOut = async (e,logout)=> {
    e.preventDefault();
      if(logout==="logout")
      {
      const token = sessionStorage.getItem('refreshtoken'); // Replace with your actual token
      const apiUrl = [severProperties.serverURL,"/auth/logout"].join("");
      fetch(apiUrl, {
        method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            'Access-Control-Allow-Origin': severProperties.serverCORS,
          },
      })
        .then((response) => { resetUserSession();navigate('/'); } )
        .catch((error)=>{
         })
      }
    };

    const doDownloadReport = async (e,download)=> {
    e.preventDefault();
      if(download==="download")
      {
        navigate('/downloadReport');
      }
    };

    
    const doInformation = async (e,information)=> {
    e.preventDefault();
      if(information==="information")
      {
        navigate('/information');
      }
    };
    

    
    const doCommunication = async (e,communication)=> {
    e.preventDefault();
      if(communication==="communication")
      {
        navigate('/communication');
      }
    };

    
    const doApplication = async (e,application)=> {
    e.preventDefault();
      if(application==="application")
      {
        navigate('/certificate');
      }
    };
  return (
    <div sticky="top" style={{width: '100vw','display': 'flex',justifyContent: 'space-between',backgroundColor:'white'  }}>
    <div className="container" style={{'height':'70px','max-width':'100vw'}}>
        <div className="box left">
        <table style={{marginTop:12}}>
          <tbody>
          <tr>
          <td>
        <div className='header-logo'></div>
        </td>
        <td>
        <div style={{'marginBottom':'20',fontSize:28,color:'navy'}}>JIMS Applicant Portal</div>
        </td>
        </tr>
        </tbody>
        </table>
        </div>
         <div className="glass-button box right" style={{marginTop:15,marginLeft:-20}}>
               <IconButton color="secondary" aria-label="download" style={{marginRight:5}}>
                  <div style={{'fontSize' : '10px'}}>              
            <FontAwesomeIcon icon={faTableCellsLarge}  onClick={(e,logout)=>doApplication(e,'application')} style={{marginTop:'-20',marginBottom:'0',width:50,height:45,color:'navy'}} />
                  <p style={{height:5,color:'navy'}}>
                  Application</p> 
                  </div>
            </IconButton>
            
            <IconButton color="secondary" aria-label="download"style={{marginRight:5}}>
              <div style={{'fontSize' : '10px'}}>              
            <FontAwesomeIcon icon={faFolder} onClick={(e,logout)=>doDownloadReport(e,'download')} style={{marginTop:'-17',marginBottom:'3',width:45,height:41,color:'navy'}}/>
             <p style={{height:5,color:'navy'}}>
                  Files</p> 
              </div>
            </IconButton>
           
            <IconButton color="secondary" aria-label="Information"style={{marginRight:5}}>
              <div style={{'fontSize' : '10px'}}> 
            <FontAwesomeIcon icon={faCircleInfo} onClick={(e,logout)=>doInformation(e,'information')} style={{marginTop:'-20',marginBottom:'0',width:50,height:45,color:'navy'}}/>
             <p style={{height:5,color:'navy'}}> Information </p> 
              </div>
            </IconButton>
           
            <IconButton color="secondary" aria-label="Communication"style={{marginRight:5}}>
              <div style={{'fontSize' : '10px'}}> 
            <FontAwesomeIcon icon={faComments}  onClick={(e,logout)=>doCommunication(e,'communication')} style={{marginTop:'-21',marginBottom:'3',width:45,height:43,color:'navy'}}/>
              <p style={{height:5,color:'navy'}}>Communication </p>
              </div>
            </IconButton>
           
              <IconButton color="secondary" aria-label="logout">
                  <div style={{'fontSize' : '10px'}}> 
              <ExitToAppIcon  onClick={(e,logout)=>doUserLogOut(e,'logout')} style={{marginTop:'-22',marginBottom:'7',width:43,height:43,color:'navy'}}/>
                <p style={{height:5,color:'navy'}}>Logout </p>
                </div>
              </IconButton>
           </div>
        
      </div>
    </div>
  )
}
export default HeaderMenu;